"use client";

import GitHubIcon from "@/assets/icons/github.svg";
import GoogleIcon from "@/assets/icons/google.svg";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { supabaseSignInWithGitHub } from "@/server-actions/supabase-auth/sign_in_with_github";
import { supabaseSignInWithGoogle } from "@/server-actions/supabase-auth/sign_in_with_google";

export function OAuthButtons({ redirectUrl }: { redirectUrl: string | null }) {
  return (
    <div className="flex flex-col gap-3">
      <form action={supabaseSignInWithGoogle}>
        {redirectUrl && (
          <input type="hidden" name="redirect" value={redirectUrl} />
        )}
        <Button
          type="submit"
          variant="outline"
          size="lg"
          className={cn(
            "h-12 w-full gap-3 rounded-lg border-zinc-200 bg-white text-base font-medium text-zinc-700",
            "transition-all hover:border-zinc-300 hover:bg-zinc-50",
            "dark:border-zinc-700 dark:bg-zinc-800/50 dark:text-zinc-200 dark:hover:border-zinc-600 dark:hover:bg-zinc-800",
          )}
        >
          <GoogleIcon className="size-5" />
          Continue with Google
        </Button>
      </form>

      <form action={supabaseSignInWithGitHub}>
        {redirectUrl && (
          <input type="hidden" name="redirect" value={redirectUrl} />
        )}
        <Button
          type="submit"
          variant="outline"
          size="lg"
          className={cn(
            "h-12 w-full gap-3 rounded-lg border-zinc-200 bg-white text-base font-medium text-zinc-700",
            "transition-all hover:border-zinc-300 hover:bg-zinc-50",
            "dark:border-zinc-700 dark:bg-zinc-800/50 dark:text-zinc-200 dark:hover:border-zinc-600 dark:hover:bg-zinc-800",
          )}
        >
          <GitHubIcon className="size-5" />
          Continue with GitHub
        </Button>
      </form>
    </div>
  );
}
